import { Howl } from 'howler';

class SoundEffects {
    constructor() {
        // Sounds are lazily initialized only when enabled
        this.sounds = null;
        this.enabled = false; // Disabled by default until user enables audio
    }

    _initSounds() {
        // Only initialize sounds when actually enabled (lazy loading)
        if (this.sounds) return;

        this.sounds = {
            click: new Howl({
                src: ['/assets/sounds/click.mp3'],
                volume: 0.3,
                html5: true,
                preload: false
            }),
            hover: new Howl({
                src: ['/assets/sounds/hover.mp3'],
                volume: 0.15,
                html5: true,
                preload: false
            }),
            success: new Howl({
                src: ['/assets/sounds/success.mp3'],
                volume: 0.4,
                html5: true,
                preload: false
            }),
            themeChange: new Howl({
                src: ['/assets/sounds/theme-change.mp3'],
                volume: 0.25,
                html5: true,
                preload: false
            }),
            cash: new Howl({
                src: ['/assets/sounds/cash.mp3'],
                volume: 0.5,
                html5: true,
                preload: false
            })
        };
    }

    play(soundName) {
        if (this.enabled && this.sounds && this.sounds[soundName]) {
            try {
                this.sounds[soundName].play();
            } catch (e) {
                // Silently fail if sound can't play
            }
        }
    }

    setEnabled(enabled) {
        this.enabled = enabled;
        if (enabled) {
            this._initSounds();
        }
    }
}

export const soundEffects = new SoundEffects();
